import React from 'react'
import SunDashboard from '@/components/sun/SunDashboard'

/**
 * "Delivery Management", on its own route.
 *
 * The place to see and change what you get, when, and where: deliveries
 * grouped by day, paused deliveries, delivery address and driver instructions.
 * It renders SunDashboard in `management` view so it shares the same
 * subscriptions, holidays, amendments and every editing dialog rather than
 * duplicating them.
 */
function DeliveryManagement(): React.JSX.Element {
  return (
    <div className="dashboard">
      <SunDashboard view="management" />
    </div>
  )
}

export default DeliveryManagement
